import { ApiEndPointsType } from "./models/api-end-points-type.model";
import { FieldTypeEnum, FromFieldType } from "./models/form-field.model";
import { RoutingPathType } from "./models/routing-url.model";
import { TableHeaderColumnType } from "./models/table-header-column-type.model";

export class AppConstants {
    public static ENC_RULES = { "R": "Ef4YsO2cbQZ2", "W": "U4Bai5Qn1ZCp", "q": "zR2H8Cd5maEc", "a": "yUz4P1a7Dz6v", "E": "Xm5VaT2B7c9a" };
    public static AES_algorithm = { "V0": "aes-256-ecb", "V1": "aes-256-ecb", "V2": "aes-256-cbc" };
    public static ENC_seprator = "rE7pRxTGlqT6";


    // routing urls
    public static RoutingPaths: RoutingPathType = {
        login: '/login',
        dashboard: 'admin/dashboard',
        upload_claims: 'admin/batch/batch-scoring',
        view_batch_records: 'admin/batch/view-batch-records',
        view_results: 'admin/batch/view-results',
        model_view_results: 'admin/model-results/model-view-results',
        model_analyze: 'admin/model-results/model-analyze',
        user_profile: 'admin/user-management/user-profile',
        add_user: 'admin/user-management/add-user'
    }

    public static LocalStorage = {
        IsAdmin: 'isAdmin',
        IsLoggedIn: 'isLoggedIn',
        IsCustomer: 'isCustomer',
        LoggedUserDetails: 'loggedUserDetails',
        Params: 'param',
        InspectionStatus: 'inspectionStatus',
        DashBoardStartDate: 'dashBoardStartDate',
        DashBoardEndDate: 'DashBoardEndDate',
        userID: 'userID',
        accountDetails: 'accountDetails',
        billinDetails: 'billinDetails',
        orderDetails: 'orderDetails',
        users: 'users',
        loggedAccountDetails: 'loggedAccountDetails',
        userProfileDetails: 'userProfileDetails'
    };
    public static apis_end_points: ApiEndPointsType = {
        login: '/model/service/generic/user/login',
        logout: '/model/service/generic/user/signout',
        dashboard_kapis: '/model/service/dashboard/user/counts',
        account_config: "/model/service/dashboard/user/account-config",
        usage_trends: "/model/service/dashboard/model-calls/usage-trends",
        dashboard_results_month: '/model/service/dashboard/model-calls/result/month',
        dashboard_results_month_records: '/model/service/dashboard/model-calls/result/month/records',
        dashboard_usage_distribution: '/model/service/dashboard/model-calls/result/usage-distribution',
        // batch scoring
        batch_scoring_upload_csv_files: '/model/service/dashboard/upload-csv-files',
        batch_scoring_pre_process: '/model/service/dashboard/pre-process',
        batch_scoring_validate: '/model/service/dashboard/validate',
        batch_scoring_model_run: '/model/service/dashboard/run-modelapi-for-batch',
        batch_scoring_batch_list: '/model/service/dashboard/search-batch-list',
        batch_scoring_export: '/model/service/dashboard/export-search-batch-list',
        batch_scoring_view_batch_records_list: '/model/service/dashboard/search-batch-records-list',
        view_results_export: '/model/service/dashboard/export-bulk-score-view-result',
        view_batch_records_list_export: '/model/service/dashboard/export-search-batch-records-list',
        get_record_information: '/model/service/dashboard/get-record-information',
        batch_scoring_view_result_list: '/model/service/dashboard/bulk-score-view-result-list',
        // MOdel Results
        model_results_model_call_list: '/model/service/dashboard/model-call-list',
        model_results_feedback: "/model/service/dashboard/feedback",
        model_results_export: '/model/service/dashboard/export-model-call-list',
        // Analyze Tab
        analyze_batch_list: '/model/service/dashboard/model-analyze-list',
        analyze_Policy_State: '/model/service/generic/get-states-list',
        analyze_batch_ids: '/model/service/generic/get-batch-list',
        analyze_model_analyze: '/model/service/dashboard/model-analyze',
        analyze_batch_export: '/model/service/dashboard/export-model-analyze-list',
        // User Tab
        user_management_emailslist: "/model/service/dashboard/user/emails-list",
        user_management_user_list: '/model/service/dashboard/search-user',
        user_management_view_user: '/model/service/dashboard/view-user',
        user_management_add_user: '/model/service/dashboard/add-user-to-existing-account',
        user_management_by_user_export: '/model/service/dashboard/export-searched-user-list',
        user_management_get_enabledUser: '/model/service/dashboard/update-user-status',
        user_management_change_password: '/model/service/dashboard/usermanagement-change-password',
        user_management_edit_user: '/model/service/dashboard/edit-user',
        user_management_emailsID: "/model/service/dashboard/user/emails-list",
        //Account Settings
        account_details: '/model/service/dashboard/account/user/details',
        account_details_purge: '/model/service/dashboard/purge-data',
        //shared Apis
        model_results_typeofmodels: '/model/service/generic/get-model-list',
        account_details_states: '/model/service/dashboard/states',
        login_change_password: '/model/service/generic/user/change-password',
        login_email_exists: '/model/service/generic/user/email/exists',
        login_reset_password: '/model/service/generic/user/reset-password',
        constact_support_list: "/model/service/dashboard/get-support-list",
        add_contact_support_ticket: '/model/service/dashboard/create-contact-support',
        contact_attachment: '/model/service/dashboard/attachment-upload'
    }





    // Screen fiels list
    public static readonly field_names: {
        changes_password: FromFieldType[];
        bulk_scoring_fields: FromFieldType[];
        view_batch_records_fields: FromFieldType[];
        view_results_fields: FromFieldType[];
        model_view_results_fields: FromFieldType[];
        model_analyze_fields: FromFieldType[];
        policy_details_fields: FromFieldType[];
        vehicle_details_fields: FromFieldType[];
        driver_details_fields: FromFieldType[];
        add_user_fields: any[];
        user_profile_fields: FromFieldType[];
        user_list_fields: FromFieldType[];
        user_profile_view_fields: FromFieldType[];
        user_password_fields: FromFieldType[];
        forgetPassword_fields: FromFieldType[]
    } = {
            forgetPassword_fields: [
                {
                    type: FieldTypeEnum.Password,
                    name: 'SecurityCode',
                    label: 'Security Code',
                    placeholder: 'Enter Security Code',
                    value: '',
                    column: 'col-sm-12',
                    required: true,
                    maxLength: 30
                },
                {
                    type: FieldTypeEnum.Password,
                    name: 'newPassword',
                    label: 'New Password',
                    placeholder: 'Enter New Password',
                    value: '',
                    column: 'col-sm-12',
                    required: true,
                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Password,
                    name: 'confirmPassword',
                    label: 'Confirm Password',
                    placeholder: 'Enter Confirm Password',
                    value: '',
                    column: 'col-sm-12',
                    required: true,
                    maxLength: 20
                }
            ],
            changes_password: [
                {
                    type: FieldTypeEnum.Password,
                    name: 'currentPassword',
                    label: 'Current Password',
                    placeholder: 'Enter Current Password',
                    value: '',
                    column: 'col-sm-12',
                    required: true,
                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Password,
                    name: 'password',
                    label: 'New Password',
                    placeholder: 'Enter New Password',
                    value: '',
                    column: 'col-sm-12',
                    required: true,
                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Password,
                    name: 'confirmPassword',
                    label: 'Confirm Password',
                    placeholder: 'Enter Confirm Password',
                    value: '',
                    column: 'col-sm-12',
                    required: true,
                    maxLength: 20
                },
            ],
            bulk_scoring_fields: [
                {
                    type: FieldTypeEnum.Text,
                    name: 'batch_Id',
                    label: 'Batch ID',
                    placeholder: 'Enter Batch ID',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Calendar,
                    name: 'uploaded_date',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    label: 'Processed Date',
                    value: '',
                    minDate: null,
                    maxDate: null,
                    required: false,

                },
                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'batch_status',
                    placeholder: 'Select',
                    label: 'Batch Status',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    options: [
                        { id: 'Pre-Processed', name: 'Pre-Processed' },
                        { id: 'Uploaded', name: 'Uploaded' },
                        { id: 'Validation-Passed', name: 'Validation-Passed' },
                        { id: 'Validation-Partial', name: 'Validation-Partial' },
                        { id: 'Validation-Failed', name: 'Validation-Failed' },
                    ],
                },
                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'processedBy',
                    placeholder: 'Select',
                    label: 'Processed By',
                    value: '-1',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    options: [
                        { id: '-1', name: 'All' },
                        { id: 'BULK', name: 'Batch Processed' },
                        { id: 'API', name: 'API' },
                    ],
                },
            ],
            view_batch_records_fields: [
                {
                    type: FieldTypeEnum.Text,
                    name: 'batch_Id',
                    label: 'Batch ID',
                    placeholder: 'Enter Batch ID',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: true,
                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text,
                    name: 'record_Id',
                    label: 'Record ID',
                    placeholder: 'Enter Record ID',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    maxLength: 25
                },
                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'record_type',
                    placeholder: 'Select',
                    label: 'Record Type',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    options: [

                    ],
                },
                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'state',
                    placeholder: 'Select',
                    label: 'State',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    options: [],
                },
            ],
            view_results_fields: [
                {
                    type: FieldTypeEnum.Text,
                    name: 'batch_Id',
                    label: 'Batch ID',
                    placeholder: 'Enter Batch ID',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: true,
                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text,
                    name: 'record_Id',
                    label: 'Record ID',
                    placeholder: 'Enter Record ID',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'record_type',
                    placeholder: 'Select',
                    label: 'Record Type',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    options: [

                    ],
                },
                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'model_type',
                    placeholder: 'Select',
                    label: 'Model Type',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    options: [

                    ],
                },
                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'state',
                    placeholder: 'Select',
                    label: 'State',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    options: [],
                },
            ],
            model_view_results_fields: [
                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'modelType',
                    placeholder: 'Select Model',
                    label: 'Model Type',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: false,
                    options: []
                },
                {
                    type: FieldTypeEnum.Text,
                    name: 'batchId',
                    label: 'Batch ID',
                    placeholder: 'Enter Batch ID',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    maxLength: 20
                },

                {
                    type: FieldTypeEnum.Text,
                    name: 'recordId',
                    label: 'Record ID',
                    placeholder: 'Enter Record ID',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'recordType',
                    placeholder: 'Select',
                    label: 'Record Type',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    options: []
                },
                {
                    type: FieldTypeEnum.RangeSlider,
                    name: 'ScoreBar',
                    label: 'Score Bar',
                    placeholder: 'Enter Record ID',
                    value: [0, 100],
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: false,

                },
                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'scoreRange',
                    placeholder: 'Select',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    label: 'Score Range',
                    value: '',
                    required: false,
                    options: [{
                        id: 'low', name: 'Low'
                    }, {
                        id: 'medium', name: 'Medium'
                    },
                    {
                        id: 'high', name: 'High'
                    }
                    ]
                },
                {
                    type: FieldTypeEnum.Calendar,
                    name: 'fromDate',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    label: 'Search From',
                    value: '',
                    minDate: null,
                    maxDate: null,
                    required: false,
                },
                {
                    type: FieldTypeEnum.Calendar,
                    name: 'dateto',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    label: 'Search To',
                    value: '',
                    minDate: null,
                    maxDate: null,
                    required: false,
                },

                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'modelreunid',
                    placeholder: 'Select',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    label: 'Model Run ID',
                    value: '1',
                    required: false,
                    options: [{
                        id: '1', name: 'Show Last Run Only'
                    },
                    {
                        id: '0', name: 'View All Runs'
                    }
                    ]
                },


                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'feedback',
                    placeholder: 'Select',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    label: 'Feedback Provided',
                    value: '-1',
                    required: false,
                    options: [{
                        id: '-1', name: 'All'
                    }, {
                        id: '1', name: 'Yes'
                    },
                    {
                        id: '0', name: 'No'
                    }
                    ]
                },
            ],
            model_analyze_fields: [

                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'modelType',
                    placeholder: 'Select Model',
                    label: 'Model Type',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    options: []
                },
                {
                    type: FieldTypeEnum.searchFilter,
                    name: 'batchID',
                    placeholder: 'Select Batch ID',
                    label: 'Batch ID',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: false,
                    // count: 2,
                    options: [],
                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'recordType',
                    placeholder: 'Select Record Type',
                    label: 'Record Type',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    options: []
                },

                {
                    type: FieldTypeEnum.Calendar,
                    name: 'fromDate',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    label: 'Search From',
                    value: '',
                    minDate: null,
                    maxDate: null,
                    required: false,
                },
                {
                    type: FieldTypeEnum.Calendar,
                    name: 'dateto',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    label: 'Search To',
                    value: '',
                    minDate: null,
                    maxDate: null,
                    required: false,
                },

                {
                    type: FieldTypeEnum.Text,
                    name: 'agencyName',
                    label: 'Agency Name',
                    placeholder: 'Enter Agency Name',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: false,
                    maxLength: 50
                },
                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'predictionSeverity',
                    label: 'Prediction Severity',
                    placeholder: 'Select Severity',
                    value: '',
                    options: [{ id: 'Low', name: 'Low' },
                    { id: 'Medium', name: 'Medium' },
                    { id: 'High', name: 'High' }
                    ],

                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,

                },
                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'policyState',
                    placeholder: 'Select Policy State',
                    label: 'Policy State',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    options: []
                },
                {
                    type: FieldTypeEnum.Text,
                    name: 'policyZip',
                    label: 'Policy Zip',
                    placeholder: 'Enter Policy Zip',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    maxLength: 10
                },
                {
                    type: FieldTypeEnum.Dropdown,
                    name: 'gender',
                    placeholder: 'Select Gender',
                    label: 'Gender',
                    value: '',
                    column: 'col-lg-2 col-md-2 col-sm-12',
                    required: false,
                    options: [{ id: 'M', name: 'Male' },
                    { id: 'F', name: 'Female' },
                    { id: 'U', name: 'Unspecified' }
                    ]
                }
            ],


            add_user_fields: [
                {
                    type: FieldTypeEnum.Text,
                    name: 'account_name',
                    label: 'Account Name',
                    placeholder: 'Enter Account Name',
                    value: '',
                    pattern: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 50
                },
                {
                    type: FieldTypeEnum.Text,
                    name: 'first_Name',
                    label: 'First Name',
                    placeholder: 'Enter First Name',
                    value: '',
                    pattern: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 30
                },
                {
                    type: FieldTypeEnum.Text,
                    name: 'last_Name',
                    label: 'Last Name',
                    placeholder: 'Enter Last Name',
                    value: '',
                    pattern: "",
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 30
                },
                {
                    type: FieldTypeEnum.Text,
                    name: 'designation',
                    label: 'Designation/Title',
                    placeholder: 'Enter Designation',
                    value: '',
                    pattern: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 50
                },
                {
                    type: FieldTypeEnum.Text,
                    name: 'email',
                    label: 'Email',
                    placeholder: 'Enter Email',
                    value: '',
                    pattern: '^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 50
                },
                {
                    type: FieldTypeEnum.Password,
                    name: 'password',
                    label: 'Password',
                    placeholder: 'Enter Password',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Password,
                    name: 'confirmPassword',
                    label: 'Confirm Password',
                    placeholder: 'Enter Confirm Password',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text,
                    name: 'phoneNumber',
                    label: 'Phone Number',
                    placeholder: 'Enter Phone Number',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 20
                }

            ],

            user_profile_fields: [
                {
                    type: FieldTypeEnum.Text,
                    name: 'account_name',
                    label: 'Account Name',
                    placeholder: 'Enter Account Name',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 50
                },
                {
                    type: FieldTypeEnum.searchFilter,
                    name: 'username_email',
                    label: 'Username/Email',
                    placeholder: 'Search Email',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 30,
                    options: []
                },


            ],
            user_profile_view_fields: [
                {
                    type: FieldTypeEnum.Text,
                    name: 'account_name',
                    label: 'Account Name',
                    placeholder: 'Enter Account Name',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 50
                },
                {
                    type: FieldTypeEnum.Text,
                    name: 'first_Name',
                    label: 'First Name',
                    placeholder: 'Enter First Name',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 30
                },
                {
                    type: FieldTypeEnum.Text,
                    name: 'last_Name',
                    label: 'Last Name',
                    placeholder: 'Enter Last Name',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 30
                },
                {
                    type: FieldTypeEnum.Text,
                    name: 'designation',
                    label: 'Designation/Title',
                    placeholder: 'Enter Designation',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 50
                },
                {
                    type: FieldTypeEnum.Text,
                    name: 'email',
                    label: 'Email',
                    placeholder: 'Enter Email',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text,
                    name: 'phone_Number',
                    label: 'Phone Number',
                    placeholder: 'Enter Phone Number',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 20
                }, {
                    type: FieldTypeEnum.Text,
                    name: 'registration_status',
                    label: 'Registration Status',
                    placeholder: 'Enter Registration Status',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 20
                },


            ],
            user_list_fields: [
                {
                    type: FieldTypeEnum.Text,
                    name: 'account_name',
                    label: 'Account Name',
                    placeholder: 'Enter Account Name',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: true,
                    maxLength: 50
                },
                {
                    type: FieldTypeEnum.searchFilter,
                    name: 'username_email',
                    label: 'Username/Email',
                    placeholder: 'Search Username/Email',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: false,
                    maxLength: 50,
                    options: []
                },
                {
                    type: FieldTypeEnum.Text,
                    name: 'designation',
                    label: 'Designation/Title',
                    placeholder: 'Enter Designation',
                    value: '',
                    column: 'col-lg-3 col-md-3 col-sm-12',
                    required: false,
                    maxLength: 50
                },

            ],
            user_password_fields: [




                {
                    type: FieldTypeEnum.Password,
                    name: 'password',
                    label: 'Password',
                    placeholder: 'Enter Password',
                    value: '',
                    column: 'col-sm-12',
                    required: true,
                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Password,
                    name: 'confirmPassword',
                    label: 'Confirm Password',
                    placeholder: 'Enter Confirm Password',
                    value: '',
                    column: 'col-sm-12',
                    required: true,
                    maxLength: 20
                },


            ],

            policy_details_fields: [
                {
                    type: FieldTypeEnum.Text, label: 'Record Identifier', name: 'recordID', value: 'record_id', required: false, column: 'col-lg-6 col-md-6 col-sm-12',
                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Record Type', name: 'recordType', value: 'record_type', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Term Number', name: 'renewalCount', value: 'term_num', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Record Created On', name: 'creationDate', value: 'record_dt', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Primary Driver Credit Group', name: 'primaryDriverDOB', value: 'credit_group_score', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Policy State', name: 'pol_addr_state', value: 'pol_addr_state', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Policy ZIP', name: 'pol_addr_zip', value: 'pol_addr_zip', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Policy Term', name: 'pol_term', value: 'pol_term', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Policy Program Code', name: 'pol_program', value: 'pol_program', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Policy Effective Date', name: 'pol_eff_dt', value: 'pol_eff_dt', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Policy Expiration Date', name: 'pol_exp_dt', value: 'pol_exp_dt', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Sales Channel', name: 'channel_cd', value: 'channel_cd', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },

                {
                    type: FieldTypeEnum.Text, label: 'Agency Code', name: 'agency_cd', value: 'agency_cd', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Agency Name', name: 'agency_name', value: 'agency_name', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Bodily Injury Limit', name: 'bi_coverage', value: 'bi_coverage', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Personal Injury Protection Limit', name: 'pip_coverage', value: 'pip_coverage', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Uninsured Addon', name: 'uim_flag', value: 'uim_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Accidental Death Limit', name: 'ad_coverage', value: 'ad_coverage', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Premium Amount', name: 'premium_amt', value: 'premium_amt', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Installment Amount', name: 'inst_amt', value: 'inst_amt', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },

                {
                    type: FieldTypeEnum.Text, label: 'Premium Amount Paid', name: 'premium_paid', value: 'premium_paid', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Number of Installments Paid', name: 'inst_paid', value: 'inst_paid', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Amount Owed', name: 'premium_owed', value: 'premium_owed', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Earned Premium', name: 'premium_earned', value: 'premium_earned', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },

                {
                    type: FieldTypeEnum.Text, label: 'Discount Percent', name: 'discount_pcnt', value: 'discount_pcnt', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Home Owner Discount', name: 'ho_disc_flag', value: 'ho_disc_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Claim Free Discount', name: 'no_claim_disc_flag', value: 'no_claim_disc_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Paid-In-Full Discount', name: 'pif_disc_flag', value: 'pif_disc_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },

                {
                    type: FieldTypeEnum.Text, label: 'Surcharge Amount', name: 'surcharge_amt', value: 'surcharge_amt', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Deposit Percent', name: 'deposit_pcnt', value: 'deposit_pcnt', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Installment Fee Amount', name: 'inst_fee_amt', value: 'inst_fee_amt', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Rating Plan', name: 'rating_plan', value: 'rating_plan', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Policy Charge Amount', name: 'policy_charge_amt', value: 'policy_charge_amt', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Needs Rated', name: 'rating_req_flag', value: 'rating_req_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Prior Insurance Exists', name: 'prior_ins_exists_flag', value: 'prior_ins_exists_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },

                // new feilds add for alinsco
                {
                    type: FieldTypeEnum.Text, label: 'Prior Insurance Company', name: 'prior_ins_co', value: 'prior_ins_co', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Prior Policy Expiration Date', name: 'prior_ins_exp_dt', value: 'prior_ins_exp_dt', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                // new feilds add for alinsco
                {
                    type: FieldTypeEnum.Text,
                    label: 'Package System ID',
                    name: 'package_id',
                    value: 'package_id',
                    required: false,
                    column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },



            ],
            driver_details_fields: [
                {
                    type: FieldTypeEnum.Text, label: 'Driver ID', name: 'driverID', value: 'driver_id', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Driver DOB', name: 'driverDOB', value: 'dob_dt', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                // new feilds add for alinsco
                {
                    type: FieldTypeEnum.Text, label: 'Driver Effective Age', name: 'eff_age', value: 'eff_age', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },

                {
                    type: FieldTypeEnum.Text, label: 'Gender', name: 'gender', value: 'gender', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Driver Marital Status', name: 'driverMaritalStatus', value: 'marital_status', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Driver Occupation', name: 'driverOccupation', value: 'occupation', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Relation to Applicant', name: 'relationtoApplicant', value: 'applicant_relation', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Driving License State', name: 'drivingLicenseState', value: 'driver_lic_state', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'License Status', name: 'licenseStatus', value: 'driver_lic_status', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'License Type', name: 'licenseType', value: 'lic_type', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                // new feilds add for alinsco
                {
                    type: FieldTypeEnum.Text, label: 'Years Licensed', name: 'years_licensed', value: 'years_licensed', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 0
                },
                {
                    type: FieldTypeEnum.Text, label: 'Months Licensed', name: 'months_licensed', value: 'months_licensed', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },

                {
                    type: FieldTypeEnum.Text, label: 'SDIP Points', name: 'SDIPPoints', value: 'sdip_points', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'SDIP Surcharge', name: 'SDIPSurcharge', value: 'sdip_surcharge', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Extended Non-Owned', name: 'extendedNonOwned', value: 'ext_non_owned', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Driver Training', name: 'driverTraining', value: 'training_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'MVR Status', name: 'mvrStatus', value: 'mvr_status', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
            ],
            vehicle_details_fields: [
                {
                    type: FieldTypeEnum.Text, label: 'Vehicle ID', name: 'vehicleID', value: 'vehicle_id', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Vehicle Make', name: 'vehicleMake', value: 'vehicle_make', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Vehicle Model', name: 'vehicleModel', value: 'vehicle_model', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Vehicle Year', name: 'vehicleYear', value: 'vehicle_year', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                // new feilds add for alinsco
                {
                    type: FieldTypeEnum.Text, label: 'Vehicle Body', name: 'vehicle_body', value: 'vehicle_body', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },

                {
                    type: FieldTypeEnum.Text, label: 'Purchased New', name: 'purchasedNew', value: 'new_purch_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Vehicle Usage', name: 'vehicleUsage', value: 'usage_category', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Vehicle Performance', name: 'vehiclePerformance', value: 'performance_grade', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Passive Seat Belt', name: 'passiveSeatBelt', value: 'passive_seatbelt_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Airbag', name: 'airbag', value: 'airbag_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Anti-Lock Brakes', name: 'antiLockBrakes', value: 'abs_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Anti-Theft', name: 'antiTheft', value: 'anti_theft_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: '  Odometer Reading', name: 'odo_reading', value: 'odo_reading', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },


                {
                    type: FieldTypeEnum.Text, label: 'One Way Miles', name: 'totalMiles', value: 'oneway_miles', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Garage State', name: 'garageState', value: 'garage_state', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },

                // new feilds add for alinsco
                {
                    type: FieldTypeEnum.Text, label: 'Garage Zip', name: 'garage_zip', value: 'garage_zip', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Garage County', name: 'garage_county', value: 'garage_county', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },

                {
                    type: FieldTypeEnum.Text, label: 'Property Damage Exclusion', name: 'propertyDamageExclusion', value: 'pd_exclusion_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                // new feilds add for alinsco
                {
                    type: FieldTypeEnum.Text, label: 'Liability Symbol', name: 'Liability', value: 'liab_sym', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },

                {
                    type: FieldTypeEnum.Text, label: 'Uninsured Bodily Injury', name: 'uninsuredBodilyInjury', value: 'ubi_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Uninsured Property Damage', name: 'uninsuredPropertyDamage', value: 'upd_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Medical Option', name: 'medicalOption', value: 'medical_option_flag', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                // new feilds add for alinsco
                {
                    type: FieldTypeEnum.Text, label: 'Personal Injury Protection Symbol', name: 'pip_sym', value: 'pip_sym', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },

                {
                    type: FieldTypeEnum.Text, label: 'Ownership', name: 'ownership', value: 'ownership', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Collision Coverage', name: 'collisionDeductible', value: 'coll_deductible', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },

                {
                    type: FieldTypeEnum.Text, label: 'Comprehensive Coverage', name: 'comprehensive_deductible', value: 'comp_deductible', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Towing Coverage Premium', name: 'towing_coverage_premium', value: 'towing_coverage_premium', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Vehicle Premium Amount', name: 'vehicle_premium_amt', value: 'vehicle_premium_amt', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                },
                {
                    type: FieldTypeEnum.Text, label: 'Vehicle Purchase Cost', name: 'purchase_cost', value: 'purchase_cost', required: false, column: 'col-lg-6 col-md-6 col-sm-12',

                    maxLength: 20
                }
            ],
        };
    public static Booleans = {
        True: 'true',
        False: 'false'
    };
    public static tableColumns: {
        batch_scoring_tableColumns: TableHeaderColumnType[],
        batch_scoring_view_batch_records: TableHeaderColumnType[]
        model_result__list: any[]
        analyze_model_grid: TableHeaderColumnType[]
        userList: TableHeaderColumnType[]
        subscriptionModelList: TableHeaderColumnType[]
        account_user_list: TableHeaderColumnType[]
        contact_support_header: TableHeaderColumnType[]
    } = {
            /****************************************List of Batches**************************************************/

            batch_scoring_tableColumns: [
                { field: 'Batch ID', col: 'batch_id', type: 'batch_id', width: 'auto' },
                { field: 'Processed Date', col: 'uploaded_date_time', type: 'datetime', width: 'auto' },
                { field: 'Processed By', col: 'updated_by', width: 'auto', type: 'updated_by' },
                { field: '# Records', col: 'total_records', type: 'total_records', width: 'auto' },
                { field: 'Batch Status', col: 'batch_status', width: 'auto', type: 'batch_status' },
                { field: 'Batch Action', col: 'next_action', width: 'auto', type: 'next_action' },
                { field: 'Quote Conversion Propensity', col: 'quote_status', type: 'quote_status', width: 'auto' },
                { field: 'Cancellation Propensity', col: 'cancellation_status', type: 'cancellation_status', width: 'auto' },
                { field: 'Claim Propensity', col: 'claim_status', type: 'claim_status', width: 'auto' },
                { field: 'Renewal Propensity', col: 'renewal_status', type: 'renewal_status', width: 'auto' },
                { field: 'Premium Defaulter Propensity', col: 'premium_defaulter_status', type: 'premium_defaulter_status', width: 'auto' },


            ],
            batch_scoring_view_batch_records: [
                { field: 'Record ID', col: 'record_id', width: 'auto', type: 'record_id' },
                { field: 'Record Type', col: 'record_type', width: 'auto', type: 'record_type', },
                { field: 'Effective Date', col: 'pol_eff_dt', type: 'date', width: 'auto' },
                { field: 'Policy Term', col: 'pol_term', width: 'auto', type: 'pol_term' },
                { field: 'Policy State', col: 'pol_addr_state', width: 'auto', type: 'pol_addr_state' },
                { field: 'Zip Code', col: 'pol_addr_zip', width: 'auto', type: 'pol_addr_zip' },
                { field: 'Premium Amount', col: 'premium_amt', width: 'auto', type: 'premium_amt' },
                { field: 'Validation Status', col: 'validation_status', width: 'auto', type: 'validation_status' },
            ],
            model_result__list: [
                { field: 'Record ID', col: 'record_id', width: 'auto' },
                { field: 'Record Type', col: 'record_type', width: 'auto' },
                { field: 'Quote Conversion Propensity', col: 'quote_probability', width: '220px', color: 'rgba(217, 217, 217, 0.2)' },
                { field: 'Cancellation Propensity', col: 'policy_cancellation_probability', width: '220px' },
                { field: 'Claim Propensity', col: 'claim_model_probability', width: '220px', color: 'rgba(217, 217, 217, 0.2)' },
                { field: 'Renewal Propensity', col: 'policy_renewal_probability', width: '220px' },
                { field: 'Premium Defaulter Propensity', col: 'premium_defaulter_probability', width: '220px', color: 'rgba(217, 217, 217, 0.2)' },
                { field: 'Execution Status', col: 'execution_status', width: 'auto' },

                // { field: 'Call Run Date & Time', col: 'model_run_datetime', type: 'datetime', width: 'auto' },
            ],
            analyze_model_grid: [
                { field: 'Batch ID', col: 'batch_id', width: 'auto', type: 'batch_id', },
                { field: 'Record Type', col: 'record_type', width: 'auto', type: 'record_type' },
                { field: 'Effective Date', col: 'policy_effective_date', width: '180px', type: 'date' },
                { field: 'Policy Term', col: 'policy_term', width: 'auto', type: 'policy_term' },
                { field: 'Policy State', col: 'policy_state', width: 'auto', type: 'policy_state' },
                { field: 'Propensity Score(%)', col: 'model_probability', width: 'auto', type: 'model_probability' },
                { field: 'Prediction Severity', col: 'prediction_severity', width: 'auto', type: 'prediction_severity' },
                { field: 'Execution Date', col: 'model_run_datetime', width: '180px', type: 'datetime' }
            ],
            userList: [
                { field: 'Full Name', col: 'full_name', width: 'auto', type: 'full_name' },
                { field: 'Account Name', col: 'name', width: 'auto', type: 'name' },
                { field: 'Designation/Title', col: 'designation_title', width: 'auto', type: 'designation_title' },
                { field: 'Email', col: 'contact_email', width: 'auto', type: 'contact_email' },
                { field: 'Phone Number', col: 'phone_number', width: 'auto', type: 'number' },
                { field: 'Creation Date', col: 'creation_date', width: 'auto', type: 'datetime' },
                { field: 'Disabled Date', col: 'disabled_date', width: '120px', type: 'datetime' },
                { field: 'Action', col: 'Action', width: '150px', type: 'Action' },
            ],
            subscriptionModelList: [
                { field: 'Model Name', col: 'model_name', width: 'auto', type: 'model_name' },
                { field: 'Model Version', col: 'Model_Version', width: 'auto', type: 'model_name' },
                { field: 'Subscription Type', col: 'model_subscription_type', width: 'auto', type: 'model_name' },
                { field: 'Subscription Start Date', col: 'subscription_start_date', type: 'date', width: 'auto' },
                { field: 'Subscription End Date', col: 'Subscription_End_Date', type: 'date', width: 'auto' },
                { field: 'Subscription Status  ', col: 'Subscription_Status', width: 'auto', type: 'model_name' },
                // { field: 'Disabled Date', col: 'disabled_date', width: 'auto' },
                { field: 'Action', col: 'Subscription_Status', width: 'auto', type: 'model_name' },
            ],
            account_user_list: [
                { field: 'First Name', col: 'first_name', width: 'auto', type: 'first_name' },
                { field: 'Last Name', col: 'last_name', width: 'auto', type: 'last_name' },
                { field: 'Email', col: 'contact_email', width: 'auto', type: 'contact_email' },
                { field: 'Phone number', col: 'phone_number', width: 'auto', type: 'number' },
                { field: 'Creation Date', col: 'created_on', width: 'auto', type: 'date' },
                { field: 'Last Login', col: 'last_login', width: 'auto', type: 'last_login' },
                { field: 'Disabled Date', col: 'disabled_date', width: 'auto', type: 'datetime' },
                { field: 'Action', col: 'status', width: 'auto', type: 'action' },
            ],
            contact_support_header: [
                { field: 'Message Date', col: 'message_date', width: 'auto', type: 'date' },
                { field: 'Email', col: 'email_id', width: 'auto', type: 'record_type', },
                { field: 'Contact Number', col: 'contact_number', type: 'contact_number', width: 'auto' },
                { field: 'Message', col: 'message', width: '350px', type: 'message' },
                { field: 'Status', col: 'action', width: 'auto', type: 'action' },
                { field: 'Comments ', col: 'comments', width: 'auto', type: 'comments' },
            ],
        }





}